export class HelperDate {

    static getDate(date: Date) {
        const {day, month, year} = this.getComponents(date);
        return day + '.' + month + '.' + year;
    }

    static getComponents(date: Date) {
        let day = String(date.getDate());
        let month = String(date.getMonth() + 1);
        let year = date.getFullYear();
        if (parseInt(day) < 10) {
            day = '0' + day;
        }
        if (parseInt(month) < 10) {
            month = '0' + month;
        }
        let hours: string | number = date.getHours();
        if (hours < 10) {
            hours = '0' + hours;
        }
        let minutes: string | number = date.getMinutes();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        let second: string | number  = date.getSeconds();
        if (second < 10) {
            second = '0' + second;
        }
        return {day, month, year, hours, minutes, second}
    }

    static getDateBD(date: Date) {
        const {day, month, year} = this.getComponents(date);
        return year + '-' + month + '-' + day;
    }

    static getTime(date: Date) {
        const {hours, minutes, second} = this.getComponents(date);
        return hours + ':' + minutes + ':' + second;
    }

}
